// Auto-generated — do not edit.
// SHA-256 digest of the OpenAPI spec this SDK was generated from.
export const SPEC_HASH = "sha256:fe524536c89d236f85a390f5877becc6d497fe83c039dcb2f58f8805269bcd44" as const;
